/**
 * @file: index.
 * @intro: 全局配置文件.
 * @author: zzmhot.
 * @email: zzmhot@163.com.
 * @Date: 2017/5/8 16:38.
 * @Copyright(©) 2017 by thinkive.
 *
 */

//本地存储的前缀
export const storage_prefix = 'bdth_datangholding_storage_';
//base64加密前缀
export const base64_prefix = 'bdth_datangholding_base64_';
//接入服务器接口地址根目录
export const server_base_url = '/';



// WEBPACK FOOTER //
// ./src/common/config/index.js